import {CommonModule} from '@angular/common';
import {Component, HostListener, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {CommonConstants, RoutesConstants, ImagePathConstants} from '@coreconstant';
import {lastValueFrom} from 'rxjs';
import {TerritoryService} from 'src/app/core/services/api-service/territory.service';
import {CommonBehaviorChangeService} from 'src/app/core/services/common-service/common-behavior-change.service';
import {ResponseHandlerService} from 'src/app/core/services/common-service/response-handler.service';
import {environment} from 'src/environments/environment';
import {NewsletterService} from '../../core/services/api-service/newsletter.service';

@Component({
    selector: 'app-footer',
    imports: [RouterModule, ReactiveFormsModule, CommonModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
    imagePathConstants = ImagePathConstants
    routesConstants = RoutesConstants
    commonConstants = CommonConstants

    currentYear = (new Date()).getFullYear()
    businessPortalUrl = environment.businessPortalUrl;
    settingData: any
    socialLinks: { [key: string]: string } = {};
    territoryList: any;
    joinForm!: FormGroup;
    submitted: boolean = false;
    footerTitle: any;
    showButton = false;

    constructor(
        private _commonBehaviorChangeService: CommonBehaviorChangeService,
        private _territoryService: TerritoryService,
        private _responseHandlerService: ResponseHandlerService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _newsletterService: NewsletterService,
    ) {
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit() {
        this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.submitted = false
            }
        });
        this.initializeForm();

        this._commonBehaviorChangeService.settings$
            .subscribe(data => {
                this.settingData = data;

                if (this.settingData && this.settingData.length > 0) {
                    const footerData = this.settingData.find((item: any) => item.section == 'footer');
                    this.footerTitle = footerData?.title;

                    this.settingData.forEach(platform => {
                        if (platform.section == 'social_media' && platform.title && platform.url)
                            this.socialLinks[platform.title] = platform.url;
                    });
                }
            });
        this.getTerritoryList();
    }

    /**
     * Retrieves the list of territories by calling a service method and processes the response.
     */
    getTerritoryList() {
        let getListing = this._territoryService.getTerritoryList()
        lastValueFrom(getListing).then((res: any) => {
            if (res["status"]) {
                this.territoryList = res["data"];
            } else {
                this._responseHandlerService.showErrorMessageGeneral(res["message"])
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Initializes the form and applies necessary validation rules to each control.
     */
    initializeForm() {
        this.joinForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.pattern(this.commonConstants.EMAIL_REGEX)]],
        });
    }

    /**
     * Submits the form after validating form, prepares the necessary form data, and initiates the API call.
     */
    onSubmit() {
        this.submitted = true;
        this.joinForm.markAllAsTouched();
        this.joinForm.markAsDirty();

        if (this.joinForm.invalid)
            return false;

        let newslettersSubscription = this._newsletterService.newslettersSubscription(this.joinForm.value)
        lastValueFrom(newslettersSubscription).then((response: any) => {
            if (response["status"] == true) {
                this.submitted = false;
                this.joinForm.reset()
                this._responseHandlerService.showSuccessMessageGeneral(response["message"] ?? this.commonConstants.JOIN_NEWSLETTER)
            } else {
                this._responseHandlerService.showErrorMessageGeneral(response["message"] ?? this.commonConstants.SOMETHING_WENT_WRONG)
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error);
        });
    }

    /**
     * Handles the window scroll event to determine the currently active section
     * in the viewport based on predefined section IDs.
     */
    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.showButton = window.scrollY > 200;
    }

    /**
     * Scrolls the window to the top of the page with a smooth scrolling effect.
     */
    scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

}
